import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CsPage } from 'providers/nav-controller';
import { ModalPageMarker } from 'providers/modal-page-marker';
import { UiDisplayNutrient } from 'models/display-nutrient';
import { NutritionInfoPageParams } from './nutrition-info-interface';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'page-nutrition-info',
  templateUrl: 'nutrition-info-page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  providers: [ModalPageMarker]
})
export class NutritionInfoPage extends CsPage<NutritionInfoPageParams> {
  protected LL = LL;

  get nutrients(): UiDisplayNutrient[] {
    return this.navParams.data.local?.nutrients || [];
  }

  formatTargetValue(nutrient: UiDisplayNutrient): string {
    if (!nutrient.target) return '--';

    const unit = nutrient.valueUnit || '';
    const target = nutrient.target;

    if (target.target !== undefined) {
      return `${target.target.toFixed(0)}${unit}`;
    } else if (target.min !== undefined && target.max !== undefined) {
      return `${target.min.toFixed(0)}-${target.max.toFixed(0)}${unit}`;
    } else if (target.min !== undefined) {
      return `>${target.min.toFixed(0)}${unit}`;
    } else if (target.max !== undefined) {
      return `<${target.max.toFixed(0)}${unit}`;
    }

    return '--';
  }

  formatActualValue(nutrient: UiDisplayNutrient): string {
    if (nutrient.value === undefined || nutrient.value === null || isNaN(nutrient.value)) {
      return '--';
    }
    return `${nutrient.value.toFixed(0)}${nutrient.valueUnit || ''}`;
  }

}
